import React from "react";
import { motion } from "framer-motion";
import { History } from "lucide-react";

/* "You won Progress Software, which shares the same kind of work."
 *
 * THE MOST PERSONAL FACT ON THE CARD, AND IT WAS THE THIRD BULLET. Both the
 * /recall card and the Tender Search fit card rendered a matched prior bid as
 * one more line in the reasons list — same dot, same grey, same size as
 * "nothing found on X". A reader scanning the bullets had no way to tell that
 * one of them was a fact from their own record rather than a judgement from a
 * model. It is the line most likely to change a decision, so it gets its own
 * block: a label saying where it came from, the outcome word carrying its
 * colour, the project name in bold, and the plain-English detail beneath.
 *
 * ONE COMPONENT FOR BOTH CARDS. The two screens share a payload contract on
 * purpose; a precedent styled two ways would quietly undo that.
 */

const TONE = {
  Win: { verb: "won", cls: "text-[#1F7D38]" },
  Lost: { verb: "lost", cls: "text-[#8A3F3F]" },
  Missed: { verb: "missed", cls: "text-[#7A5209]" },
  "Chose Not to Apply": { verb: "passed on", cls: "text-[#71717A]" },
};

const EASE = [0.22, 1, 0.36, 1];

export default function PrecedentBlock({ items, delay = 0 }) {
  if (!items?.length) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22, ease: EASE, delay }}
      className="mt-3 rounded-lg border border-black/[0.08] bg-white/70 px-3.5 py-3"
    >
      <p className="mb-1.5 flex items-center gap-1.5 font-outfit text-[10.5px] font-semibold uppercase tracking-[0.06em] text-[#A1A1AA]">
        <History className="h-3 w-3" />
        From your record
      </p>

      <ul className="space-y-2">
        {items.map((o, i) => {
          const tone = TONE[o.outcome] || { verb: String(o.outcome || "").toLowerCase(), cls: "text-[#71717A]" };
          return (
            <li key={`${o.project_id ?? o.project}-${i}`} className="font-outfit">
              <p className="text-[14px] leading-relaxed text-[#3F3F46]">
                You <span className={`font-semibold ${tone.cls}`}>{tone.verb}</span>{" "}
                <span className="font-semibold text-[#18181B]">{o.project}</span>
                {o.matched_on ? `, which shares ${o.matched_on}` : ""}
                {o.why ? ` — ${o.why.toLowerCase()}` : ""}.
              </p>
              {/* The specifics behind "the same kind of work", quieter than the
                  claim — what matched, what did not, in words. */}
              {o.detail && (
                <p className="mt-0.5 text-[12.5px] leading-relaxed text-[#8A8A94]">
                  {o.detail}
                </p>
              )}
            </li>
          );
        })}
      </ul>
    </motion.div>
  );
}
